module.exports = __webpack_public_path__ + "img/os-up-to-date.a8055a50.png";